import api from './api';

export type OrganizationIdentityInfo = {
  applicationName: string;
  organizations: Array<{ id: string; name: string }>;
  revision: string;
};

export const getOrganizationIdentityInfo = async (signal: AbortSignal) =>
  api
    .get('/api/interaction/organization-identity', { signal, retry: 0 })
    .json<OrganizationIdentityInfo>();

export const confirmOrganizationIdentity = async (
  organizationId: string,
  expectedRevision: string
) =>
  api
    .post('/api/interaction/organization-identity', {
      json: { organizationId, expectedRevision },
      retry: 0,
    })
    .json<{ redirectTo: string }>();

export const cancelOrganizationIdentity = async () =>
  api
    .post('/api/interaction/organization-identity/cancel', { json: {}, retry: 0 })
    .json<{ redirectTo: string }>();
